
import { blue, green, indigo, purple, warning, success, info ,error} from './colors';

export const getPrimary = (preset) => {
  switch (preset) {
    case 'blue':
      return blue;
    case 'green':
      return green;
    case 'indigo':
      return indigo;
    case 'purple':
      return purple;
    case 'warning':
      return warning;
    case 'success':
      return success;
    case 'info':
      return info;
    case 'error':
      return error;
    default:
      console.error('Invalid color preset. Accepted values: "blue", "green", "indigo", "purple", "warning", "success", or "info".');
      return blue;
  }
};
